import { render, staticRenderFns } from "./SalesReport.vue?vue&type=template&id=77c45d4c&"
import script from "./SalesReport.vue?vue&type=script&lang=js&"
export * from "./SalesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports